import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { IDT } from '@ff-os/pdp-shared-redux/IDT';
import { Dropdown } from '@ff-os/shared-react/components/dropdown/Dropdown';
import { ListItem } from '@ff-os/shared-react/components/list/ListItem';
import { useExternalFromPriceRender } from '@ff-os/shared-react/hooks/useExternalFromPriceRender';
import { VariantOption } from '../../../../VariantOption';
import styles from './VariantDropdown.module.scss';

export const VariantDropdown = ({
    value, onChange, options, className
}: Props) => {

    const selected = options.find(o => o.value === value)!;

    return (
        <Dropdown
            renderPreview={() => <OptionText {...selected} />}
            className={className}
            fieldClassName={styles.field}>

            {options.map(o => (
                <ListItem key={o.value}
                    onClick={() => onChange(o.value)}
                    active={o.value === value}>
                    <OptionText {...o} />
                </ListItem>
            ))}
        </Dropdown>
    );
};

const OptionText = ({ label, name, priceRequest, price }: VariantOption) => {
    const { t } = useTranslation();
    return (
        <span className={styles.optionText}>
            {t(name.key, name.args)}
            {label && <>: {t(label.key, label.args)}</>}
            {price && <PriceLabel>{price}</PriceLabel>}
            {priceRequest && <RequestPriceLabel priceRequest={priceRequest} />}
        </span>
    );
};

const RequestPriceLabel = ({ priceRequest }: { priceRequest: IDT.FromPriceRequest }) => {

    const { t } = useTranslation();
    const { destinationRef, plainText } = useExternalFromPriceRender(priceRequest);

    return (
        <span ref={destinationRef}>
            {plainText && <PriceLabel>{plainText} {t('photo_prints.price_apiece')}</PriceLabel>}
        </span>
    );
};

const PriceLabel = ({ children }: { children: ReactNode }) => (
    <span className={styles.price}>{children}</span>
);

type Props = {
    value: string;
    className?: string;
    onChange: (value: string) => void;
    options: VariantOption[];
};